<template>
  <div>
    <ToggleSwitch
      v-model="settings.searchEnabled"
      class="sprd-toggle-switch--first"
      label="SA.pages.productList.showSearch.label"
    />
  </div>
</template>

<script>
import { SettingsData } from 'src/app/partnerarea/pos/shop/shopSavable/SettingsData';
import ToggleSwitch from 'commons/toggleSwitch/ToggleSwitch.vue';

export default {
  name: 'Design',
  components: { ToggleSwitch },
  mixins: [SettingsData],
  created() {
    this.$store.commit('shop/setLivePreview', { path: '' });
  },
};
</script>

<style lang="scss" scoped>
:deep(.sprd-toggle-switch) {
  font-size: 16px;
}
</style>
